import { tablePaginationInitialValue } from "@sso/constant";
import { OrganisationState } from "@sso/types";

export const organisationInitialState: OrganisationState = {
  pagination: tablePaginationInitialValue,
  mergeOrgs: [],
};
